import React from "react";

export default function Page(): React.JSX.Element {
  return <></>;
}
